import React from "react";
// Constants
import { permanenceDiscount, taxConfig } from "../../../../config/constants";
// Components
import { BoxWrapper, Box, BoxRow, RowLabel, RowValue, ButtonRow, ExportButton, ExportIcon } from "./styles";
import Stepper from "../stepper";
// Assets
import { download } from "../../../../assets/icons";

const TotalsBox = ({ labels, subtotal, discount, onDiscountChange, tax, onTaxChange, finalTotal, onExportPdf }) => (
  <BoxWrapper>
    <Box>
      <BoxRow>
        <RowLabel>{labels.beforeDiscount}</RowLabel>
        <RowValue>{subtotal}</RowValue>
      </BoxRow>
      <BoxRow>
        <RowLabel>{labels.discount}</RowLabel>
        <Stepper
          value={discount}
          onChange={onDiscountChange}
          max={permanenceDiscount.max}
          step={permanenceDiscount.step}
          suffix=" %"
          width="110px"
          alignRight
        />
      </BoxRow>
      <BoxRow>
        <RowLabel>{labels.tax}</RowLabel>
        <Stepper
          value={tax}
          onChange={onTaxChange}
          max={taxConfig.max}
          step={taxConfig.step}
          suffix=" %"
          width="110px"
          alignRight
        />
      </BoxRow>
      <BoxRow>
        <RowLabel>{labels.final}</RowLabel>
        <RowValue>{finalTotal}</RowValue>
      </BoxRow>
      <ButtonRow>
        <ExportButton type="button" onClick={onExportPdf}>
          <ExportIcon src={download} alt="" />
          {labels.exportPdf}
        </ExportButton>
      </ButtonRow>
    </Box>
  </BoxWrapper>
);

export default TotalsBox;
